import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import audioManager from './audioManager'
import './assets/scss/main.scss'
import { clicky } from './directives/clicky'


document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(App)
  app.provide("audioManager", audioManager);
  app.directive('clicky', clicky)
  app.use(router)
  app.use(createPinia())

  app.mount('#app')
})
